import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable, inject, resource, computed } from "@angular/core";
import { firstValueFrom } from "rxjs";

export type AppSettings = Record<string, string | undefined>;
@Injectable()
export class AppSettingsService {
    private http = inject(HttpClient);

    public appSettings: AppSettings | null = null;
    private appSettingsLoadPromise: Promise<AppSettings> | null = null;

    protected appSettingsResource = resource<AppSettings | null, undefined>({
        defaultValue: null,
        loader: () => this.getLoadSettings(),
    });
    public sAppSettings = computed(() => this.appSettingsResource.value());

    private async loadSettings(): Promise<AppSettings> {
        if (!this.appSettings) {
            let url = "/app-settings/index.js";
            const options = {
                headers: new HttpHeaders().set("x-prevent-authorization-header", "1"),
                params: new HttpParams().set("t", Date.now().toString()),
            };
            if (
                /localhost/.test(document.location.host) ||
                /taxprepdashboard.dev-local.ca/.test(document.location.host) ||
                /dev-local.taxprepdashboard.ca/.test(document.location.host)
            ) {
                url = "/app-settings/dev-local.json";
                options.headers.set("Strict-Transport-Security", "max-age=31536000; includeSubDomains");
            }
            try {
                const data = this.http.get<AppSettings>(url, options);
                this.appSettings = await firstValueFrom(data);
            } catch (error) {
                console.error("[WK] Failed to load app settings:", error);
                this.appSettings = {};
            }
        }
        return this.appSettings;
    }

    public async getLoadSettings(): Promise<AppSettings> {
        if (!this.appSettingsLoadPromise) this.appSettingsLoadPromise = this.loadSettings();
        return this.appSettingsLoadPromise;
    }
}
